export interface IPageDataState {
  cssSrc?: string;
  jsSrc: string;
  title: string;
  mediaCopyright?: string;
  asyncJsSrcs?: ReadonlyArray<string>;
  pageParam: {
    title?: string;
    service: string;
    pagetype: string;
    conttype?: string;
    opttype: string;
    apptype: string;
    mid?: string;
    mit_serv?: string;
    ispicked?: string;
    shcid?: string;
    ctsid?: string;
    topittl?: string;
    topitime?: string;
    topiname?: string;
    rcnsid?: string;
    cat_path?: string;
    vtestid?: string;
    vtgrpid?: string;
    mtestid: string;
    v_pkjp?: number;
    payment?: string;
    acttype?: string;
    query?: string;
    ins?: string;
    rs?: number;
    hasvideo?: '0' | '1'; // 0の場合が通常記事,1の場合が動画付き記事
    modetype?: string;
    ref_raw?: string;
    ytop?: '0' | '1';
    cmt_mod?: '0' | '1' | '2';
    svy_mod?: '0' | '1';
    issueid?: string;
    amdid?: string;
    cmt_divr?: 0 | 1;
    sttype?: 'rec' | 'follow' | 'trend';
    ht_ref?: string;
    cmt_type?: '' | 'polls' | 'expert' | 'thread' | null;
    listtype?: string;
    ai_qanum?: number;
    theme?: string;
    cmt_id?: string;
  };
  yadsTypeTag?: string;
  experimentId?: string;
  path: string;
  description: string;
  twitterDescription?: string;
  type: OgType;
  ogpImage?: string;
  ogpImageWidth?: number;
  ogpImageHeight?: number;
  ogpDescription?: string;
  ogpUrl?: string;
  jsonLdImages?: string[];
  twitterImage?: string;
  twitterSite?: string;
  noIndex?: boolean;
  pubDate?: Date;
  updateDate?: Date;
  pickupId?: string;
  articleId?: string;
  expertArticleId?: string;
  contentId?: string;
  isPay?: boolean;
  isPurchased?: boolean;
  currentPage?: number;
  isEnableJsonLD?: boolean;
  isNoIndexNoFollow?: boolean;
  isIndex?: boolean;
  yads: {
    shannonId?: string;
    categoryId: string;
  };
  isCheerCommentMode?: boolean;
  issueId?: number;
  /** canonicalタグを出力するかどうか。canonicalPathが指定されている場合は値に関わらず出力される */
  isCanonical?: boolean;
  /** canonicalタグに指定するパス。pathより優先される */
  canonicalPath?: string;
  enableAppLink?: boolean;
}

const initialState: IPageDataState = {
  cssSrc: '',
  jsSrc: '',
  title: '',
  pageParam: {
    service: '',
    pagetype: '',
    opttype: '',
    apptype: '',
    mtestid: ''
  },
  path: '',
  description: '',
  type: 'website',
  yads: {
    categoryId: ''
  }
};
export default (state: IPageDataState = initialState) => {
  return state;
};
